import React, { useEffect, useRef, useState } from "react";
import Modal from "react-responsive-modal";
import { useDispatch } from "react-redux";
import { Descriptions } from "antd";
import { callApi } from "../../config/apiCall";
import { toast } from "react-toastify";
import { getAdminTicketData } from "../../redux/actions/adminAction";

const AddTicket = ({ open, onClose, user }) => {
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
    const [isLoading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        category: "",
        attachments: "",
        // created_by: userDetails?.user?.id
    });
    // console.log("userDetails" ,userDetails);
    

    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    const handleFileClick = () => {
        fileInputRef.current.click();
    };
    const onchange = (e) => {
        const { name, value, type } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: type == "file" ? e.target.files : value
        }))
    };
    const handleSubmit = async () => {
        try {
            setLoading(true)
            const data = new FormData()
            Object.entries(formData)?.map(([key, value]) => {
                if (key == "attachments" && value instanceof FileList) {
                    for (let i = 0; i < value.length; i++) {
                        data.append("attachments[]", value[i]); // "attachments[]" is a common convention
                    }
                } else {
                    data.append(key, value)
                }
            })
            data.append("created_by", userDetails?.user?.id)
            const response = await callApi("tickets", "POST", data, userDetails?.token)
            console.log(response);
            if(!response?.valid){
                toast.warning(response?.mssg)
            }
            setLoading(false)
            if (response?.success) {
                onClose();
                toast.success(response?.mssg)
                dispatch(getAdminTicketData({ path: `tickets/users/${userDetails?.user?.id}` }))
                setFormData({
                    title: "",
                    description: "",
                    category: "",
                    attachments: "",
                    created_by: ""
                })
            } else {
                toast.error(response?.mssg)
            }

        } catch (error) {
            setLoading(false)
            console.log(error);
            toast.error(error?.response?.data?.message || error?.message)

        }

    };


    return (
        <Modal
            open={open}
            onClose={onClose}
            center
            showCloseIcon={false}
            closeOnOverlayClick={false}
            classNames={{ modal: "custom-modal1322" }}
        >
            <div className="wfh-container">
                <h2 className="wfh-title">
                    Raise a ticket
                </h2>
                <p className="wfh-subtitle">
                    You can share any concern or seek help from your organization
                </p>

                <div className="input-group">
                    <label className="input-label">Need Help Regarding</label>
                    <select
                        className="input-field"
                        value={formData?.category}
                        type="text"
                        onChange={onchange}
                        name="category"
                        required
                    >
                        <option value="">Select </option>
                        <option value="Internet Issue">Internet Issue</option>
                        <option value="Redistribute">Redistribute</option>
                        <option value="Computer">Computer</option>
                        <option value="Complaint">Complaint</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div className="input-group">
                    <label className="input-label">Title</label>
                    <input
                        className="input-field"
                        value={formData?.title}
                        type="text"
                        name="title"
                        onChange={onchange}
                        required
                    />

                </div>
                <div className="input-group">
                    <label className="input-label">Issue</label>
                    <textarea
                        className="input-field textarea"
                        placeholder="Please share the assistance required"
                        value={formData?.description}
                        name="description"
                        required
                        onChange={onchange}
                    />
                </div>
                <div className="date-container">
                    <div className="date-container">
                        <button
                            type="button"
                            className="btn btn-outline-primary bg-white  d-flex align-items-center gap-2"
                            onClick={handleFileClick}
                        >
                            <i className="fa fa-paperclip" aria-hidden="true"></i>
                            Attach Files
                        </button>

                        {/* Hidden file input */}
                        <input
                            type="file"
                            ref={fileInputRef}
                            multiple
                            name="attachments"
                            className="d-none"
                            onChange={onchange}
                        />
                    </div>
                </div>

                <div className="button-group">
                    <button
                        className="btn cancel"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn submit"
                        onClick={() => {
                            if (!isLoading) {
                                handleSubmit();
                            }
                        }}
                    >
                        {
                            isLoading ? "Loading ..." : "Submit Request"
                        }
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default AddTicket;
